import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { ThemeProvider } from "./components/providers/ThemeProvider";
import { TooltipProvider } from "./components/ui/tooltip";
import { AuthProvider } from "./contexts/auth";
import { DownloadsProvider } from "./contexts/DownloadsContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { queryClient } from "./lib/query-client";
import Routes from "./routes";

const FallbackComponent = () => {
  return (
    <div className="error-boundary">
      <h1>Desculpe, algo deu errado.</h1>
      <p>Ocorreu um erro inesperado. Por favor, tente recarregar a página.</p>
      <button onClick={() => window.location.reload()}>
        Recarregar página
      </button>
    </div>
  );
};

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SidebarProvider>
            <DownloadsProvider>
              <Toaster richColors position="top-center" />
              <ThemeProvider defaultTheme="system" storageKey="verden-ui-theme">
                <TooltipProvider delayDuration={200}>
                  <Routes />
                </TooltipProvider>
              </ThemeProvider>
            </DownloadsProvider>
          </SidebarProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
